import React from "react";
import PropTypes from "prop-types";
import FilterControls from "components/source/new_taxonomy/filter-controls";
import FacetFilters from "components/source/new_taxonomy/facet-filters";
import FilterHelpers from "helpers/filter-helpers";
import { isStorefrontNext } from "helpers/environment-helpers";

const propTypes = {
  closeModal: PropTypes.func,
  errors: PropTypes.object,
  expandFilters: PropTypes.func,
  filterOptions: PropTypes.object,
  getFieldsetHeader: PropTypes.func,
  hideSizeFilter: PropTypes.bool,
  isFilterOpen: PropTypes.func.isRequired,
  isHomeGoodGrid: PropTypes.bool,
  onApply: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  onClearFilter: PropTypes.func,
  onClearFilters: PropTypes.func.isRequired,
  onToggleOpenFilters: PropTypes.func.isRequired,
  openFilters: PropTypes.array.isRequired,
  renderRTRFilters: PropTypes.func.isRequired,
  renderSpecialFields: PropTypes.func,
  submitFilters: PropTypes.func.isRequired,
  workingFilters: PropTypes.object.isRequired,
  isDeadEndTextSearch: PropTypes.bool,
  showLimitedFilterSet: PropTypes.bool,
  showSizeFilter: PropTypes.bool,
};

export default class AttributeFilterModalContent extends React.Component {
  constructor(props) {
    super(props);
    this.className = "attribute-filter-modal-content";
    this.state = {
      filterStatus: this.props.workingFilters,
    };
  }

  filtersHaveChanged() {
    // FilterHelpers.getDiff() returns an array of filter fieldSets whose values
    // have changed. E.g., if I initially selected a size and formality,
    // diff would be ["canonicalSizes", "formality"]
    const diff = FilterHelpers.getDiff(this.props.workingFilters, this.state.filterStatus);

    return Array.isArray(diff) && diff.length > 0;
  }

  renderFilterControls() {
    const filtersChanged = this.filtersHaveChanged();

    // If no filters have been changed, we close the modal and maintain
    // the scroll position on the grid. If filters have changed, we
    // close and return to the top of the grid.
    const onCloseFunction = filtersChanged ? this.props.onApply : this.props.closeModal;

    return (
      <FilterControls
        onClearFilters={this.props.onClearFilters}
        filtersHaveChanged={filtersChanged}
        closeModal={onCloseFunction}
      />
    );
  }

  renderSpecialFields() {
    if (this.props.renderSpecialFields) {
      return this.props.renderSpecialFields();
    }

    return null;
  }

  // Necessary to hide "root" categories from the count for VIEW ALL grids on SF next
  removeRootCategoryFromEpicCategories(inputFilters) {
    const rootCategories = ["WomensApparel", "WomensAccessories"];
    const filters = { ...inputFilters };

    // Check if epicCategories exists in the input object and is an array
    if (inputFilters.epicCategories) {
      // Filter out any category in rootCategories
      filters.epicCategories = inputFilters.epicCategories.filter(category => !rootCategories.includes(category));
    }
    return filters;
  }

  getWorkingFilters() {
    if (isStorefrontNext()) {
      return this.removeRootCategoryFromEpicCategories(this.props.workingFilters);
    }

    return this.props.workingFilters;
  }

  renderFacetFilters() {
    return (
      <FacetFilters
        id="facetfilt"
        key="facet"
        errors={this.props.errors}
        expandFilters={this.props.expandFilters}
        filters={this.getWorkingFilters()}
        filterOptions={this.props.filterOptions}
        isFilterOpen={this.props.isFilterOpen}
        idSuffix="-modal"
        onChange={this.props.onChange}
        onClearFilter={this.props.onClearFilter}
        onToggleOpenFilters={this.props.onToggleOpenFilters}
        openFilters={this.props.openFilters}
        submitFilters={this.props.submitFilters}
        getFieldsetHeader={this.props.getFieldsetHeader}
        hideSizeFilter={this.props.hideSizeFilter}
        isHomeGoodGrid={this.props.isHomeGoodGrid}
        isDeadEndTextSearch={this.props.isDeadEndTextSearch}
        showLimitedFilterSet={this.props.showLimitedFilterSet}
        showSizeFilter={this.props.showSizeFilter}
        renderRTRFilters={this.props.renderRTRFilters}></FacetFilters>
    );
  }

  render() {
    if (!this.props.filterOptions) {
      return <div>{this.renderSpecialFields()}</div>;
    }

    return (
      <div className={this.className}>
        <div className={`${this.className}__container`}>
          <div key="filter-header" className="filters-header mq__desktop">
            <h3 className="h3">Filters</h3>
            <button className="label" onClick={this.props.onClearFilters}>
              Clear All
            </button>
          </div>
          {this.renderSpecialFields()}
          {this.renderFacetFilters()}
        </div>
        {this.renderFilterControls()}
      </div>
    );
  }
}

AttributeFilterModalContent.propTypes = propTypes;
